import React, { createContext, useContext, useState } from 'react';
import { IVoteVoterView, IVoteBallotView, IVoteBallotProxyView } from '../types/voteTypes'; // Adjust path if needed

type VotingContextType = {
    voter: IVoteVoterView | null;
    setVoter: (voter: IVoteVoterView | null) => void;
    ballot: IVoteBallotView | null;
    setBallot: (ballot: IVoteBallotView | null) => void;
    proxyInfo: IVoteBallotProxyView | null;
    setProxyInfo: (proxyInfo: IVoteBallotProxyView | null) => void;
    previewId: String | null;
    setPreviewId: (previewId: String | null) => void;
    isPreview: boolean | null;
    setPreview: (isPreview: boolean | null) => void;
    isAdmin: boolean | null;
    setAdmin: (isAdmin: boolean | null) => void;
};

const VotingContext = createContext<VotingContextType | undefined>(undefined);

export const VotingProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [voter, setVoter] = useState<IVoteVoterView | null>(null);
    const [ballot, setBallot] = useState<IVoteBallotView | null>(null);
    const [proxyInfo, setProxyInfo] = useState<IVoteBallotProxyView | null>(null);
    const [previewId, setPreviewId] = useState<String | null>(null);
    const [isPreview, setPreview] = useState<boolean | null>(null);
    const [isAdmin, setAdmin] = useState<boolean | null>(null);

    return (
        <VotingContext.Provider value={{
            voter, setVoter, ballot, setBallot, proxyInfo, setProxyInfo, previewId,
            setPreviewId, isPreview, setPreview, isAdmin, setAdmin
        }}>
            {children}
        </VotingContext.Provider>
    );
};

export const useVoting = (): VotingContextType => {
    const context = useContext(VotingContext);
    if (!context) {
        throw new Error('useVoting must be used within a VotingProvider');
    }
    return context;
};